export type RestrictionType =
  "ban_comment" | "ban_edit" | "ban_publish" | "block";

export type StatusRestriction = {
  id: number;
  type: RestrictionType;
  reason: string;
  isPermanent: boolean;
  expiresAt: string | null;
};

export type Restriction = StatusRestriction & {
  isActive: boolean;
  createdAt: string;
  createdBy: number;
  liftedAt: string | null;
  liftedBy: number | null;
  liftReason: string;
};

export const RESTRICTION_LABELS: Record<RestrictionType, string> = {
  ban_comment: "Запрет комментариев",
  ban_edit: "Запрет редактирования контента",
  ban_publish: "Запрет публикации нового контента",
  block: "Полная блокировка аккаунта",
};
